import * as React from "react";

import { analytics } from "@/analytics";
import { FeatureTier, ProgramSchema } from "@/api-client";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/ui/link";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Urls } from "@/domain/urls";

interface UpgradeButtonProps {
  organizationId: number;
  isAdmin: boolean;
  activeProgram: ProgramSchema | undefined;
}

export const UpgradeButton: React.FC<UpgradeButtonProps> = ({
  organizationId,
  isAdmin,
  activeProgram,
}) => {
  const action =
    activeProgram?.tier === FeatureTier.Free ||
    activeProgram?.tier === FeatureTier.Essentials ||
    activeProgram?.tier === FeatureTier.Basic
      ? "Upgrade"
      : "Change";

  const tooltipContent = isAdmin ? (
    activeProgram?.tier === FeatureTier.Enterprise ? (
      <>
        <Link href="mailto:support@coiled.io" className="text-inherit">
          Contact us
        </Link>
        {" to make changes to your Enterprise plan"}
      </>
    ) : null
  ) : (
    <>Contact your organization admin to {action.toLowerCase()} your plan</>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span>
          <Button
            variant={
              !isAdmin || activeProgram?.tier === FeatureTier.Enterprise
                ? "outline"
                : "default"
            }
            disabled={
              !isAdmin || activeProgram?.tier === FeatureTier.Enterprise
            }
            asChild={isAdmin && activeProgram?.tier !== FeatureTier.Enterprise}
            onClick={() => {
              if (isAdmin && activeProgram?.tier !== FeatureTier.Enterprise) {
                analytics.track(`${action.toLowerCase()}-subscription-click`, {
                  organizationId,
                });
              }
            }}
          >
            {isAdmin && activeProgram?.tier !== FeatureTier.Enterprise ? (
              <Link to={`/${Urls.Pricing}`} asChild>
                <span>{action} Your Plan</span>
              </Link>
            ) : (
              <span>{action} Your Plan</span>
            )}
          </Button>
        </span>
      </TooltipTrigger>
      {tooltipContent && (
        <TooltipContent className="max-w-48 text-center">
          <div>{tooltipContent}</div>
        </TooltipContent>
      )}
    </Tooltip>
  );
};
